// src/features/workos/config/workos.js
const workosConfig = {
  clientId: import.meta.env.VITE_WORKOS_CLIENT_ID,
  redirectUri: import.meta.env.VITE_WORKOS_REDIRECT_URI || 'https://contextui.ai/.netlify/functions/oauth-callback',
};

// Validate config (only check for client ID)
if (!workosConfig.clientId) {
  console.error('Missing VITE_WORKOS_CLIENT_ID in environment variables');
}

export default workosConfig;